import React, { useEffect, useState } from "react"

import {
    Card,
    CardBody,
    Col,
    Row,
    CardTitle,
    FormGroup,
    Form,
    Label
} from "reactstrap"

import Select from "react-select"

import { connect } from "react-redux";
import { useDispatch } from 'react-redux';

//Import Action to copy breadcrumb items from local state to redux state
import { setBreadcrumbItems } from "../../store/actions";
import { useSelector } from "react-redux";
import Loader from "components/Loader/Loader";
import { useNavigate } from "react-router-dom";
import { createLevel } from "helpers/level_helper";
import { toast } from "react-toastify";


const CreateDifficulty = (props) => {
    document.title = "Content Management | Create Level";



    const breadcrumbItems = [
        { title: "Level", link: "#" },
        { title: "Create Level", link: "#" },
    ]
    useEffect(() => {
        const blurDiv = document.getElementById("blur");
        var width = window.innerWidth;
        if (width <= 994) {
            blurDiv.click()
        }
    }, [])

    useEffect(() => {
        props.setBreadcrumbItems('Create Level', breadcrumbItems)
    })

    const [name, setName] = useState("");
    const [loader, setLoader] = useState(false);
    const [spanDisplay, setSpanDisplay] = useState("none");
    const dispatch = useDispatch();
    const [another, setAnother] = useState(false);
    const navigate = useNavigate();





    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!name) {
            setSpanDisplay("inline")

        }
        else {

            try {
                setLoader(true);
                const result = await createLevel({ name });
                if (result?.success) {
                    toast.success(result?.message);

                    setName("");
                }
                else {
                    toast.error(result?.message);
                }
            } catch (error) {
                toast.error(error?.response?.data?.message);
            } finally {
                setLoader(false)
            }



        }

    };








    return (
        <React.Fragment>
            {loader ? (
                <Loader />
            ) : ("")}
            <Row>
                <Col>
                    <Card>
                        <CardBody className="col-xl-10 col-lg-10 col-md-10 col-sm-12 col-xs-12">
                            <CardTitle className="h4">Create Level</CardTitle>
                            <form onSubmit={handleSubmit}>


                                <Row className="mb-3">
                                    <label
                                        htmlFor="example-text-input"
                                        className="col-md-2 col-form-label"
                                    >
                                        Level Name
                                    </label>
                                    <div className="col-md-10">
                                        <input type="text"
                                            className='form-control'
                                            placeholder="Enter new Level"
                                            maxLength="50"
                                            value={name}
                                            onChange={(e) => setName(e.target.value)} />
                                        {!name && <span style={{ color: "red", display: spanDisplay }}>This feild is required</span>}
                                    </div>
                                </Row>



                                <Row className="mb-3">
                                    <div className="mt-4">
                                        <button type="submit" className="btn btn-primary w-md">Create</button>
                                    </div>
                                </Row>
                            </form>

                        </CardBody>
                    </Card>
                </Col>
            </Row>



        </React.Fragment>
    )
}

export default connect(null, { setBreadcrumbItems })(CreateDifficulty);